import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-victor-dashboard',
  templateUrl: './victor-dashboard.component.html',
  styleUrls: ['./victor-dashboard.component.css']
})
export class VictorDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
